module.exports = __webpack_public_path__ + "bugs-notify-6f8c56200ea06e69c2858bce1ea75400.webp";